import { CartesianGrid } from "recharts";
import { CHART_COLORS } from "src/ui/colors";
import { chartStrokeDasharray } from "./chart-utils";

type RenderCartesianGridProps = {
  /**
   * Whether to render vertical grid lines. If enabled, the first and last ticks are hidden so there are no vertical grid outlines.
   * @default false
   *
   * Only use `true` for line and area charts.
   */
  vertical?: boolean;
};

/**
 * Cartesian grid with dashed, horizontal lines.
 * Vertical lines are displayed for line and area charts, based on the `vertical` prop.
 *
 * A note about all the recharts `render[...]` functions:
 * Ideally we would factor these out into proper React components, however
 * Recharts has internal state sharing that breaks custom components: https://github.com/recharts/recharts/issues/2788
 * In Recharts v3 this will work, but until we upgrade we need to use this function pattern.
 * Also see: https://github.com/recharts/recharts/wiki/3.0-migration-guide#custom-components
 */
export const renderCartesianGrid = ({
  vertical = false,
}: RenderCartesianGridProps = {}) => (
  <CartesianGrid
    stroke={CHART_COLORS.gray.divider}
    strokeDasharray={chartStrokeDasharray}
    vertical={vertical}
  />
);
